const fileFromBase64 = (string64, fileName) => {
	const pos = string64.indexOf(';base64,');
	const b64 = string64.substr(pos + 8);
	const imageContent = atob(b64);
	const buffer = new ArrayBuffer(imageContent.length);
	const view = new Uint8Array(buffer);

	for (let n = 0; n < imageContent.length; n++) {
		view[n] = imageContent.charCodeAt(n);
	}
	const type = string64.substring(5, pos);
	const blob = new Blob([buffer], { type });
	return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}

export default fileFromBase64